import React from 'react';

import {EntityLogo} from "../../logos/entity-logo";
import classNames from "classnames";
import styles from "./odds-tooltip.content.module.scss";
import {OptionOldRate} from "../../option-rates/option-old-rate.js";
import {OptionCurrentRate} from "../../option-rates/option-current-rate.js";
import {OddsTooltipContentPreMatchRate} from "./odds-tooltip.content.pre-match-rate";
import {OddsTooltipContentTrend} from "./odds-tooltip.content.trend";
import {OddsTooltipContentOriginalRate} from "./odds-tooltip.content.original-rate";
import {Link} from "../../link/link";
import {LINK_REL} from "../../../consts";

export const OddsTooltipContent = ({
                                     option,
                                     controller,
                                     bookieHrefModel,
                                     betsImpressionParams,
                                     bookmaker,
                                     onClick,
                                     showBookieLogo,
                                     contentClassName,
                                     showOriginalOdds
                                   }) => {
  const logoProps = {
    entity: bookmaker,
    height: option.isPreMatchRateValid ? 32 : 20,
    width: option.isPreMatchRateValid ? 102 : 62,
  };

  const canClickBookie = !!onClick && !!bookieHrefModel;

  const linkProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    className: classNames(styles.container, contentClassName, {[styles.not_clickable]: !canClickBookie}),
    onClick: canClickBookie ? (e) => {
      e.stopPropagation();

      return onClick?.()
    } : undefined
  };

  const rateProps = {
    option,
    controller,
    betsImpressionParams,
  }

  return (
    <Link {...linkProps}>
      {
        showBookieLogo && bookmaker ? <EntityLogo {...logoProps}/> : null
      }
      <div className={classNames(styles.all_rates)}>
        <div className={classNames(styles.current_rates)}>
          <OptionOldRate {...rateProps} className={classNames(styles.old_rate)}/>
          <OddsTooltipContentTrend option={option}/>
          <OptionCurrentRate {...rateProps} className={classNames(styles.current_rate)}/>
        </div>
        <OddsTooltipContentPreMatchRate {...rateProps}/>
        {
          showOriginalOdds ? <OddsTooltipContentOriginalRate {...rateProps}/> : null
        }
      </div>
    </Link>
  )
};
